import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  saveDraftBtn: {
    textTransform: 'none'
  }
});
